import "./Steps.css"

import Documents from "./Documents"
import Fees from "./Fees"

const Steps = props => {
  return (
    <div className="data-center-page">
      <div className="row">
        <div className="col-md-3">
          <div className="ie-center">
            <div className="text-center">
              <div className="d-inline-block ">
                <div className="circle-number ie-center">
                  <span>1</span>
                </div>
              </div>
              <div className="span-x-title">
                Required documents for your application
              </div>
              <Documents type={props.type} />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="ie-center">
            <div style={{ textAlign: "center" }}>
              <div style={{ display: "inline-block" }}>
                <div className="circle-number ie-center">
                  <span>2</span>
                </div>
              </div>
              <div className="span-x-title"> Payable fee for the license</div>
              <Fees type="plastics" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="ie-center">
            <div style={{ textAlign: "center" }}>
              <div style={{ display: "inline-block" }}>
                <div className="circle-number ie-center">
                  <span>3</span>
                </div>
              </div>
              <div className="span-x-title">License Validity</div>
              <div>
                <div className="simple-card-first">
                  <div className="simple-big-title">
                    <span>{props.licenseValidity}</span>
                  </div>
                  <div className="simple-small-title">
                    <span>Year</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="ie-center">
            <div style={{ textAlign: "center" }}>
              <div style={{ display: "inline-block" }}>
                <div className="circle-number ie-center">
                  <span>4</span>
                </div>
              </div>
              <div className="span-x-title">Processing time</div>
              <div>
                <div className="simple-card">
                  <div className="simple-big-title">
                    <span>{props.processingTime}</span>
                  </div>
                  <div className="simple-small-title" style={{ marginTop: 10 }}>
                    <span>Within {props.processingTime} days</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col"></div>
      </div>

      <div className="row">
        <div className="col-12"></div>
      </div>

      <div className="tend-to-bottom"></div>
    </div>
  )
}

export default Steps
